// GET History
export const GET_ODONTOGRAM_HISTORY_REQUEST = 'GET_ODONTOGRAM_HISTORY_REQUEST'
export const GET_ODONTOGRAM_HISTORY_SUCCESS = 'GET_ODONTOGRAM_HISTORY_SUCCESS'
export const GET_ODONTOGRAM_HISTORY_FAIL = 'GET_ODONTOGRAM_HISTORY_FAIL'

// SAVE (POST)
export const SAVE_ODONTOGRAM_REQUEST = 'SAVE_ODONTOGRAM_REQUEST'
export const SAVE_ODONTOGRAM_SUCCESS = 'SAVE_ODONTOGRAM_SUCCESS'
export const SAVE_ODONTOGRAM_FAIL = 'SAVE_ODONTOGRAM_FAIL'

// UPDATE (PATCH)
export const UPDATE_ODONTOGRAM_REQUEST = 'UPDATE_ODONTOGRAM_REQUEST'
export const UPDATE_ODONTOGRAM_SUCCESS = 'UPDATE_ODONTOGRAM_SUCCESS'
export const UPDATE_ODONTOGRAM_FAIL = 'UPDATE_ODONTOGRAM_FAIL'

// DELETE
export const DELETE_ODONTOGRAM_REQUEST = 'DELETE_ODONTOGRAM_REQUEST'
export const DELETE_ODONTOGRAM_SUCCESS = 'DELETE_ODONTOGRAM_SUCCESS'
export const DELETE_ODONTOGRAM_FAIL = 'DELETE_ODONTOGRAM_FAIL'

// CLEAR
export const CLEAR_ODONTOGRAM_DATA = 'CLEAR_ODONTOGRAM_DATA'

// GET Patient Vital Sign List
export const GET_LIST_PATIENT_VITALSIGN_REQUEST = 'GET_LIST_PATIENT_VITALSIGN_REQUEST'
export const GET_LIST_PATIENT_VITALSIGN_SUCCESS = 'GET_LIST_PATIENT_VITALSIGN_SUCCESS'
export const GET_LIST_PATIENT_VITALSIGN_FAIL = 'GET_LIST_PATIENT_VITALSIGN_FAIL'

// DOWNLOAD User Guidance
export const DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_REQUEST = 'DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_REQUEST'
export const DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_SUCCESS = 'DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_SUCCESS'
export const DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_FAIL = 'DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_FAIL'
